<template>
    <div class="r-panel-title">
        <Icon :type="icon" v-if="icon" class="icon" />
        <img class="all_comment" src="../assets/icons/all_comment.png" alt="" v-if="img == 'all'">
        <van-icon v-if="vanticon" name="fire" color="#d9b581" />
        <span class="text">
            {{ text }}
        </span>
        <small>{{ desc }}</small>
        <div class="extra">
            <slot name="extra"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'panel-title',
        props: {
            icon: String,
            desc: String,
            text: String,
            vanticon: String,
            img: String
        }
    }
</script>

<style lang="less" scoped>
    .r-panel-title {
        display: flex;
        align-items: center;
        padding: .6rem .5rem;
        position: relative;
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 1rem);
            height: .05rem;
            border-bottom: .05rem dashed #9E9E9E;
        }
        .icon {
            transform: translateY(-0.05rem);
        }
        .all_comment {
            width: .7rem;
            height: .7rem;
            margin-right: .25rem;
        }

        .van-icon {
            transform: translateY(-0.05rem);
            width: 1rem;
            margin-right: .25rem;
        }

        .ivu-icon.icon {
            margin-right: .25rem;
            color: #d9b581;
            width: 1rem;
            text-align: center;
            font-size: 1rem;
        }

        span {
            font-weight: bold;
        }
        .text {
            font-size: .7rem;
            color: #000;
            font-weight: 400;
        }

        small {
            color: #d9b581;
            margin-left: .25rem;
        }

        .extra {
            position: absolute;
            right: .5rem;
        }
    }
</style>